import Select, { SingleValue } from 'react-select'
import { countryFromCode, getCountriesAsOptions, SelectOption } from '@shared/helpers/countryHelper'
import S from './CountryPicker.module.scss';
import { useEffect, useMemo, useState } from 'react';

interface CountryPickerProps {
    selectedCountryCode: string,
    onUpdate: (option: SelectOption) => void,
    maxVisibleOptions?: number;
}

export const CountryPicker = ({ selectedCountryCode, onUpdate, maxVisibleOptions }: CountryPickerProps) => {   
    const options = useMemo(getCountriesAsOptions, []);
    const [selectedOption, setSelectedOption] = useState<SelectOption>();

    const optionHeight = 36;

    useEffect(() => {
        setSelectedOption({
            value: selectedCountryCode || '',
            label: `${countryFromCode(selectedCountryCode || "")} (${selectedCountryCode})` 
        })
    }, [selectedCountryCode]);

    const handleSelection = (newValue: SingleValue<SelectOption>) => {
        const newSelection = {
            value: newValue?.value || '',
            label: newValue?.label || '' 
        }
        setSelectedOption(newSelection);
        onUpdate(newSelection);
    }

    return options && selectedOption ? (
        <Select
            className={S.countryPicker}
            options={options}
            value={selectedOption}
            onChange={handleSelection}
            maxMenuHeight={maxVisibleOptions && optionHeight * maxVisibleOptions}
        />
    ) : null
}
